import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const open_1_fisso = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1f" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1f" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={60} h={84} />
  </svg>
);

export const open_1_battente_sx = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1bs" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1bs" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={60} h={84} side="left" />
  </svg>
);

export const open_1_battente_dx = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1bd" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1bd" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={60} h={84} side="right" />
  </svg>
);

export const open_1_antaribalta_sx = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1as" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1as" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={60} h={84} side="left" />
  </svg>
);

export const open_1_antaribalta_dx = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1ad" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1ad" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={60} h={84} side="right" />
  </svg>
);

export const open_1_vasistas = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1v" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1v" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <VasistasFill x={10} y={8} w={60} h={84} />
  </svg>
);

export const open_1_bilico_h = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1bh" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1bh" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BilicoH x={10} y={8} w={60} h={84} />
  </svg>
);

export const open_1_bilico_v = () => (
  <svg viewBox="0 0 80 100" className="w-full h-full">
    <GlassGradient id="g_o1bv" />
    <GlassPanel x={10} y={8} w={60} h={84} gradId="g_o1bv" />
    <rect x={4} y={4} width={72} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BilicoV x={10} y={8} w={60} h={84} />
  </svg>
);

export const open_2_fisso_fisso = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2ff" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2ff" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2ff" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={38} h={84} />
    <FixedMark x={52} y={8} w={38} h={84} />
  </svg>
);

export const open_2_batt_sx_batt_dx = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2bb" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2bb" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2bb" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={38} h={84} side="left" />
    <BattenteTriangleFill x={52} y={8} w={38} h={84} side="right" />
  </svg>
);

export const open_2_ar_sx_ar_dx = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2aa" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2aa" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2aa" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={38} h={84} side="left" />
    <AntaRibaltaFill x={52} y={8} w={38} h={84} side="right" />
  </svg>
);

export const open_2_fisso_batt_dx = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2fbd" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2fbd" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2fbd" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={38} h={84} />
    <BattenteTriangleFill x={52} y={8} w={38} h={84} side="right" />
  </svg>
);

export const open_2_batt_sx_fisso = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2bsf" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2bsf" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2bsf" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={38} h={84} side="left" />
    <FixedMark x={52} y={8} w={38} h={84} />
  </svg>
);

export const open_2_fisso_ar_dx = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2fad" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2fad" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2fad" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={38} h={84} />
    <AntaRibaltaFill x={52} y={8} w={38} h={84} side="right" />
  </svg>
);

export const open_2_ar_sx_fisso = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2asf" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2asf" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2asf" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={38} h={84} side="left" />
    <FixedMark x={52} y={8} w={38} h={84} />
  </svg>
);

export const open_2_batt_sx_ar_dx = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2bad" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2bad" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2bad" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={38} h={84} side="left" />
    <AntaRibaltaFill x={52} y={8} w={38} h={84} side="right" />
  </svg>
);

export const open_2_ar_sx_batt_dx = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2abd" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2abd" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2abd" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={38} h={84} side="left" />
    <BattenteTriangleFill x={52} y={8} w={38} h={84} side="right" />
  </svg>
);

export const open_2_fisso_vas = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2fv" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2fv" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2fv" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={38} h={84} />
    <VasistasFill x={52} y={8} w={38} h={84} />
  </svg>
);

export const open_2_vas_fisso = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2vf" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2vf" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2vf" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <VasistasFill x={10} y={8} w={38} h={84} />
    <FixedMark x={52} y={8} w={38} h={84} />
  </svg>
);

export const open_2_vas_vas = () => (
  <svg viewBox="0 0 100 100" className="w-full h-full">
    <GlassGradient id="g_o2vv" />
    <GlassPanel x={10} y={8} w={38} h={84} gradId="g_o2vv" />
    <GlassPanel x={52} y={8} w={38} h={84} gradId="g_o2vv" />
    <rect x={4} y={4} width={92} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <VasistasFill x={10} y={8} w={38} h={84} />
    <VasistasFill x={52} y={8} w={38} h={84} />
  </svg>
);

export const open_3_fff = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3fff" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3fff" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3fff" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3fff" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={30} h={84} />
    <FixedMark x={44} y={8} w={32} h={84} />
    <FixedMark x={80} y={8} w={30} h={84} />
  </svg>
);

export const open_3_bsf_bd = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3bfb" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3bfb" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3bfb" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3bfb" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={30} h={84} side="left" />
    <FixedMark x={44} y={8} w={32} h={84} />
    <BattenteTriangleFill x={80} y={8} w={30} h={84} side="right" />
  </svg>
);

export const open_3_ar_f_ar = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3afa" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3afa" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3afa" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3afa" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={30} h={84} side="left" />
    <FixedMark x={44} y={8} w={32} h={84} />
    <AntaRibaltaFill x={80} y={8} w={30} h={84} side="right" />
  </svg>
);

export const open_3_f_bs_bd = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3fbb" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3fbb" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3fbb" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3fbb" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={30} h={84} />
    <BattenteTriangleFill x={44} y={8} w={32} h={84} side="left" />
    <BattenteTriangleFill x={80} y={8} w={30} h={84} side="right" />
  </svg>
);

export const open_3_bs_bd_f = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3bbf" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3bbf" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3bbf" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3bbf" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={30} h={84} side="left" />
    <BattenteTriangleFill x={44} y={8} w={32} h={84} side="right" />
    <FixedMark x={80} y={8} w={30} h={84} />
  </svg>
);

export const open_3_ar_ar_f = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3aaf" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3aaf" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3aaf" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3aaf" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={10} y={8} w={30} h={84} side="left" />
    <AntaRibaltaFill x={44} y={8} w={32} h={84} side="right" />
    <FixedMark x={80} y={8} w={30} h={84} />
  </svg>
);

export const open_3_f_ar_ar = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3faa" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3faa" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3faa" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3faa" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={10} y={8} w={30} h={84} />
    <AntaRibaltaFill x={44} y={8} w={32} h={84} side="left" />
    <AntaRibaltaFill x={80} y={8} w={30} h={84} side="right" />
  </svg>
);

export const open_3_bs_bd_bd = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_o3bbb" />
    <GlassPanel x={10} y={8} w={30} h={84} gradId="g_o3bbb" />
    <GlassPanel x={44} y={8} w={32} h={84} gradId="g_o3bbb" />
    <GlassPanel x={80} y={8} w={30} h={84} gradId="g_o3bbb" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={10} y={8} w={30} h={84} side="left" />
    <BattenteTriangleFill x={44} y={8} w={32} h={84} side="right" />
    <BattenteTriangleFill x={80} y={8} w={30} h={84} side="right" />
  </svg>
);

export const open_pf1_battente_sx = () => (
  <svg viewBox="0 0 60 120" className="w-full h-full">
    <GlassGradient id="g_pf1bs" />
    <GlassPanel x={8} y={6} w={44} h={108} gradId="g_pf1bs" />
    <rect x={4} y={4} width={52} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={6} w={44} h={108} side="left" />
  </svg>
);

export const open_pf1_battente_dx = () => (
  <svg viewBox="0 0 60 120" className="w-full h-full">
    <GlassGradient id="g_pf1bd" />
    <GlassPanel x={8} y={6} w={44} h={108} gradId="g_pf1bd" />
    <rect x={4} y={4} width={52} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={6} w={44} h={108} side="right" />
  </svg>
);

export const open_pf1_ar_sx = () => (
  <svg viewBox="0 0 60 120" className="w-full h-full">
    <GlassGradient id="g_pf1as" />
    <GlassPanel x={8} y={6} w={44} h={108} gradId="g_pf1as" />
    <rect x={4} y={4} width={52} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={8} y={6} w={44} h={108} side="left" />
  </svg>
);

export const open_pf1_ar_dx = () => (
  <svg viewBox="0 0 60 120" className="w-full h-full">
    <GlassGradient id="g_pf1ad" />
    <GlassPanel x={8} y={6} w={44} h={108} gradId="g_pf1ad" />
    <rect x={4} y={4} width={52} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={8} y={6} w={44} h={108} side="right" />
  </svg>
);

export const open_pf2_batt_batt = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2bb" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2bb" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2bb" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={6} w={35} h={108} side="left" />
    <BattenteTriangleFill x={47} y={6} w={35} h={108} side="right" />
  </svg>
);

export const open_pf2_ar_ar = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2aa" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2aa" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2aa" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={8} y={6} w={35} h={108} side="left" />
    <AntaRibaltaFill x={47} y={6} w={35} h={108} side="right" />
  </svg>
);

export const open_pf2_fisso_batt = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2fb" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2fb" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2fb" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={8} y={6} w={35} h={108} />
    <BattenteTriangleFill x={47} y={6} w={35} h={108} side="right" />
  </svg>
);

export const open_pf2_batt_fisso = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2bf" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2bf" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2bf" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={6} w={35} h={108} side="left" />
    <FixedMark x={47} y={6} w={35} h={108} />
  </svg>
);

export const open_pf2_fisso_ar = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2fa" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2fa" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2fa" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={8} y={6} w={35} h={108} />
    <AntaRibaltaFill x={47} y={6} w={35} h={108} side="right" />
  </svg>
);

export const open_pf2_ar_fisso = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2af" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2af" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2af" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={8} y={6} w={35} h={108} side="left" />
    <FixedMark x={47} y={6} w={35} h={108} />
  </svg>
);

export const open_pf2_batt_ar = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2ba" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2ba" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2ba" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <BattenteTriangleFill x={8} y={6} w={35} h={108} side="left" />
    <AntaRibaltaFill x={47} y={6} w={35} h={108} side="right" />
  </svg>
);

export const open_pf2_ar_batt = () => (
  <svg viewBox="0 0 90 120" className="w-full h-full">
    <GlassGradient id="g_pf2ab" />
    <GlassPanel x={8} y={6} w={35} h={108} gradId="g_pf2ab" />
    <GlassPanel x={47} y={6} w={35} h={108} gradId="g_pf2ab" />
    <rect x={4} y={4} width={82} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <AntaRibaltaFill x={8} y={6} w={35} h={108} side="left" />
    <BattenteTriangleFill x={47} y={6} w={35} h={108} side="right" />
  </svg>
);

export const open_scor2_sx = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_s2sx" />
    <GlassPanel x={8} y={8} w={52} h={84} gradId="g_s2sx" />
    <GlassPanel x={60} y={8} w={52} h={84} gradId="g_s2sx" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={25} y={50} direction="right" length={25} />
  </svg>
);

export const open_scor2_dx = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_s2dx" />
    <GlassPanel x={8} y={8} w={52} h={84} gradId="g_s2dx" />
    <GlassPanel x={60} y={8} w={52} h={84} gradId="g_s2dx" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={95} y={50} direction="left" length={25} />
  </svg>
);

export const open_scor2_centrale = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_s2c" />
    <GlassPanel x={8} y={8} w={52} h={84} gradId="g_s2c" />
    <GlassPanel x={60} y={8} w={52} h={84} gradId="g_s2c" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={45} y={50} direction="left" length={20} />
    <SlidingArrow x={75} y={50} direction="right" length={20} />
  </svg>
);

export const open_scor3_sx = () => (
  <svg viewBox="0 0 140 100" className="w-full h-full">
    <GlassGradient id="g_s3sx" />
    <GlassPanel x={8} y={8} w={40} h={84} gradId="g_s3sx" />
    <GlassPanel x={52} y={8} w={40} h={84} gradId="g_s3sx" />
    <GlassPanel x={96} y={8} w={40} h={84} gradId="g_s3sx" />
    <rect x={4} y={4} width={132} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={20} y={50} direction="right" length={20} />
    <FixedMark x={52} y={8} w={40} h={84} />
    <FixedMark x={96} y={8} w={40} h={84} />
  </svg>
);

export const open_scor3_dx = () => (
  <svg viewBox="0 0 140 100" className="w-full h-full">
    <GlassGradient id="g_s3dx" />
    <GlassPanel x={8} y={8} w={40} h={84} gradId="g_s3dx" />
    <GlassPanel x={52} y={8} w={40} h={84} gradId="g_s3dx" />
    <GlassPanel x={96} y={8} w={40} h={84} gradId="g_s3dx" />
    <rect x={4} y={4} width={132} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={8} y={8} w={40} h={84} />
    <FixedMark x={52} y={8} w={40} h={84} />
    <SlidingArrow x={125} y={50} direction="left" length={20} />
  </svg>
);

export const open_scor3_centro = () => (
  <svg viewBox="0 0 140 100" className="w-full h-full">
    <GlassGradient id="g_s3c" />
    <GlassPanel x={8} y={8} w={40} h={84} gradId="g_s3c" />
    <GlassPanel x={52} y={8} w={40} h={84} gradId="g_s3c" />
    <GlassPanel x={96} y={8} w={40} h={84} gradId="g_s3c" />
    <rect x={4} y={4} width={132} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <FixedMark x={8} y={8} w={40} h={84} />
    <SlidingArrow x={65} y={50} direction="right" length={15} />
    <FixedMark x={96} y={8} w={40} h={84} />
  </svg>
);

export const open_scor4_centrale = () => (
  <svg viewBox="0 0 160 100" className="w-full h-full">
    <GlassGradient id="g_s4c" />
    <GlassPanel x={8} y={8} w={35} h={84} gradId="g_s4c" />
    <GlassPanel x={43} y={8} w={35} h={84} gradId="g_s4c" />
    <GlassPanel x={82} y={8} w={35} h={84} gradId="g_s4c" />
    <GlassPanel x={117} y={8} w={35} h={84} gradId="g_s4c" />
    <rect x={4} y={4} width={152} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={43} y1={8} x2={43} y2={92} stroke="#222" strokeWidth="0.8" />
    <line x1={78} y1={8} x2={78} y2={92} stroke="#222" strokeWidth="0.8" />
    <line x1={117} y1={8} x2={117} y2={92} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={35} h={84} />
    <SlidingArrow x={55} y={50} direction="left" length={15} />
    <SlidingArrow x={100} y={50} direction="right" length={15} />
    <FixedMark x={117} y={8} w={35} h={84} />
  </svg>
);

export const open_patio2_sr_dx = () => (
  <svg viewBox="0 0 120 120" className="w-full h-full">
    <GlassGradient id="g_p2d" />
    <GlassPanel x={8} y={8} w={52} h={104} gradId="g_p2d" />
    <GlassPanel x={60} y={8} w={52} h={104} gradId="g_p2d" />
    <rect x={4} y={4} width={112} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={60} y1={8} x2={60} y2={112} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={52} h={104} />
    {/* SR DX: sliding arrow + tilt triangle dashed */}
    <SlidingArrow x={95} y={60} direction="left" length={20} />
    <polygon points="86,8 60,112 112,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_patio2_sr_sx = () => (
  <svg viewBox="0 0 120 120" className="w-full h-full">
    <GlassGradient id="g_p2s" />
    <GlassPanel x={8} y={8} w={52} h={104} gradId="g_p2s" />
    <GlassPanel x={60} y={8} w={52} h={104} gradId="g_p2s" />
    <rect x={4} y={4} width={112} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={60} y1={8} x2={60} y2={112} stroke="#222" strokeWidth="0.8" />
    {/* SR SX: sliding arrow + tilt triangle dashed */}
    <SlidingArrow x={25} y={60} direction="right" length={20} />
    <polygon points="34,8 8,112 60,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
    <FixedMark x={60} y={8} w={52} h={104} />
  </svg>
);

export const open_patio2_sr_sr = () => (
  <svg viewBox="0 0 120 120" className="w-full h-full">
    <GlassGradient id="g_p2ss" />
    <GlassPanel x={8} y={8} w={52} h={104} gradId="g_p2ss" />
    <GlassPanel x={60} y={8} w={52} h={104} gradId="g_p2ss" />
    <rect x={4} y={4} width={112} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={60} y1={8} x2={60} y2={112} stroke="#222" strokeWidth="0.8" />
    <SlidingArrow x={25} y={60} direction="right" length={18} />
    <polygon points="34,8 8,112 60,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
    <SlidingArrow x={95} y={60} direction="left" length={18} />
    <polygon points="86,8 60,112 112,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="4,2" />
  </svg>
);

export const open_patio3_f_sr_sx_f = () => (
  <svg viewBox="0 0 140 120" className="w-full h-full">
    <GlassGradient id="g_p3sx" />
    <GlassPanel x={8} y={8} w={40} h={104} gradId="g_p3sx" />
    <GlassPanel x={52} y={8} w={40} h={104} gradId="g_p3sx" />
    <GlassPanel x={96} y={8} w={40} h={104} gradId="g_p3sx" />
    <rect x={4} y={4} width={132} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={52} y1={8} x2={52} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={96} y1={8} x2={96} y2={112} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={40} h={104} />
    <SlidingArrow x={60} y={60} direction="left" length={15} />
    <polygon points="72,8 52,112 92,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    <FixedMark x={96} y={8} w={40} h={104} />
  </svg>
);

export const open_patio3_f_sr_dx_f = () => (
  <svg viewBox="0 0 140 120" className="w-full h-full">
    <GlassGradient id="g_p3dx" />
    <GlassPanel x={8} y={8} w={40} h={104} gradId="g_p3dx" />
    <GlassPanel x={52} y={8} w={40} h={104} gradId="g_p3dx" />
    <GlassPanel x={96} y={8} w={40} h={104} gradId="g_p3dx" />
    <rect x={4} y={4} width={132} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={52} y1={8} x2={52} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={96} y1={8} x2={96} y2={112} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={40} h={104} />
    <SlidingArrow x={84} y={60} direction="right" length={15} />
    <polygon points="72,8 52,112 92,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    <FixedMark x={96} y={8} w={40} h={104} />
  </svg>
);

export const open_patio4_f_sr_sr_f = () => (
  <svg viewBox="0 0 160 120" className="w-full h-full">
    <GlassGradient id="g_p4fssf" />
    <GlassPanel x={8} y={8} w={35} h={104} gradId="g_p4fssf" />
    <GlassPanel x={47} y={8} w={35} h={104} gradId="g_p4fssf" />
    <GlassPanel x={86} y={8} w={35} h={104} gradId="g_p4fssf" />
    <GlassPanel x={125} y={8} w={35} h={104} gradId="g_p4fssf" />
    <rect x={4} y={4} width={152} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={47} y1={8} x2={47} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={86} y1={8} x2={86} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={125} y1={8} x2={125} y2={112} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={35} h={104} />
    {/* Centrale SX apre verso fisso SX */}
    <SlidingArrow x={55} y={60} direction="left" length={12} />
    <polygon points="64,8 47,112 82,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    {/* Centrale DX apre verso fisso DX */}
    <SlidingArrow x={112} y={60} direction="right" length={12} />
    <polygon points="103,8 86,112 121,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    <FixedMark x={125} y={8} w={35} h={104} />
  </svg>
);

export const open_patio4_sr_sr_f_f = () => (
  <svg viewBox="0 0 160 120" className="w-full h-full">
    <GlassGradient id="g_p4ssff" />
    <GlassPanel x={8} y={8} w={35} h={104} gradId="g_p4ssff" />
    <GlassPanel x={47} y={8} w={35} h={104} gradId="g_p4ssff" />
    <GlassPanel x={86} y={8} w={35} h={104} gradId="g_p4ssff" />
    <GlassPanel x={125} y={8} w={35} h={104} gradId="g_p4ssff" />
    <rect x={4} y={4} width={152} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={47} y1={8} x2={47} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={86} y1={8} x2={86} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={125} y1={8} x2={125} y2={112} stroke="#222" strokeWidth="0.8" />
    <SlidingArrow x={16} y={60} direction="left" length={12} />
    <polygon points="25,8 8,112 43,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    <SlidingArrow x={55} y={60} direction="left" length={12} />
    <polygon points="64,8 47,112 82,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    <FixedMark x={86} y={8} w={35} h={104} />
    <FixedMark x={125} y={8} w={35} h={104} />
  </svg>
);

export const open_patio4_f_f_sr_sr = () => (
  <svg viewBox="0 0 160 120" className="w-full h-full">
    <GlassGradient id="g_p4ffss" />
    <GlassPanel x={8} y={8} w={35} h={104} gradId="g_p4ffss" />
    <GlassPanel x={47} y={8} w={35} h={104} gradId="g_p4ffss" />
    <GlassPanel x={86} y={8} w={35} h={104} gradId="g_p4ffss" />
    <GlassPanel x={125} y={8} w={35} h={104} gradId="g_p4ffss" />
    <rect x={4} y={4} width={152} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={47} y1={8} x2={47} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={86} y1={8} x2={86} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={125} y1={8} x2={125} y2={112} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={35} h={104} />
    <FixedMark x={47} y={8} w={35} h={104} />
    <SlidingArrow x={112} y={60} direction="right" length={12} />
    <polygon points="103,8 86,112 121,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
    <SlidingArrow x={151} y={60} direction="right" length={12} />
    <polygon points="142,8 125,112 156,112" fill="none" stroke="#0055CC" strokeWidth="1" strokeDasharray="3,2" />
  </svg>
);

